<div (click)="onCardClick()" style="cursor: pointer;">
  <app-metric-card
    class="coverage-card"
    [title]="'Events Pending Review'"
    [currentValue]="eventsPendingReview()?.total_events_pending_review ?? 0"
    [hideComparison]="true"
    [hidePrevious]="true"
    [suffix]="''"
    [showLeftBorder]="true"
    [showLastUpdated]="true"
    [lastUpdatedDate]="eventsPendingReview()?.last_updated ?? null"
    [lastUpdatedLabel]="'Last updated:'"
  ></app-metric-card>
</div>

<!-- Pending Review Items Modal -->
<kendo-dialog
  *ngIf="showModal()"
  (close)="closeModal()"
  [width]="'95vw'"
  [height]="'90vh'"
  [minWidth]="'800px'"
  [maxWidth]="'1400px'"
>
  <kendo-dialog-titlebar>Events Pending Review</kendo-dialog-titlebar>
  
  <div class="modal-content p-3">
    <!-- TODO: PRODUCTION - Uncomment DataTable implementation when API is ready -->
    <!-- 
    <div class="table-container" style="height: 70vh; overflow-y: auto;">
      <app-datatable
        [data-href]="dataUrl"
        [columns]="columns"
      >
        <table class="table table-striped table-hover">
          <thead>
            <tr>
              <th>Event Name</th>
              <th>Severity</th>
              <th>Date & Time</th>
              <th>Threat Type</th>
              <th>User</th>
              <th>Mailbox</th>
              <th>Details</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody></tbody>
        </table>
      </app-datatable>
    </div>
    -->
    
    <!-- PROTOTYPE - Simple table with mock data (remove when API is ready) -->
    @if (pendingReviewData()) {
      <div class="table-container" style="height: 70vh; overflow-y: auto;">
        <table class="table table-striped table-hover">
          <thead>
            <tr>
              <th>Event Name</th>
              <th>Severity</th>
              <th>Date & Time</th>
              <th>Threat Type</th>
              <th>User</th>
              <th>Mailbox</th>
              <th>Details</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            @for (item of pendingReviewData()?.items ?? []; track item.id) {
              <tr>
                <td>{{ item.eventName }}</td>
                <td>
                  <span 
                    class="badge"
                    [class.badge-danger]="item.severity === 'Critical'"
                    [class.badge-warning]="item.severity === 'High'"
                    [class.badge-info]="item.severity === 'Medium'"
                    [class.badge-secondary]="item.severity === 'Low'"
                  >
                    {{ item.severity }}
                  </span>
                </td>
                <td>{{ item.dateTime | date:'short' }}</td>
                <td>{{ item.threatType }}</td>
                <td>{{ item.user }}</td>
                <td>{{ item.mailbox }}</td>
                <td>
                  <span [title]="item.details">
                    {{ item.details.length > 50 ? (item.details | slice:0:50) + '...' : item.details }}
                  </span>
                </td>
                <td>
                  <div class="action-buttons d-flex gap-2 flex-wrap">
                    @for (action of item.available_actions; track action) {
                      <button 
                        type="button" 
                        [class]="getActionButtonClass(action)"
                        (click)="onActionClick(item, action)"
                        [title]="action"
                      >
                        {{ action }}
                      </button>
                    }
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      
      <div class="modal-footer mt-3">
        <small class="text-muted">
          Last updated: {{ pendingReviewData()?.last_updated | date:'short' }} | 
          Total items: {{ pendingReviewData()?.total_count }}
        </small>
      </div>
    } @else {
      <div class="text-center">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p class="mt-2">Loading pending review items...</p>
      </div>
    }
    <!-- END PROTOTYPE -->
    
    <!-- TODO: PRODUCTION - Update footer text when DataTable is active -->
    <!--
    <div class="modal-footer mt-3">
      <small class="text-muted">
        Events Pending Review - Real-time data with pagination, filtering, and sorting
      </small>
    </div>
    -->
  </div>
</kendo-dialog>
